import React from "react";
import Reverse from "./Reverse";
import TranslateText from "./TranslateText";
import Weather from "./Weather";
import logo from "../../logo.svg";

const Scraps: React.FC = () => {
  return (
    <>
      <h1>Scraps</h1>
      <TranslateText />
      <Reverse />
      <Weather />

      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Edit <code>src/App.js</code> and save to reload.</p>
        <a className="App-link" href="https://reactjs.org" target="_blank" rel="noopener noreferrer">Learn React</a>
      </header>

    </>
  )
};

export default Scraps;